import { BaseComponent } from '../base-component'
import { delay, $el } from '../../utils/utils'
import { ClipboardButtonTooltip } from './clipboard-button-tooltip'
import { isEnterKey } from 'src/scripts/utils/key'

export class ClipboardButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(this, 'keydown', this.handleButtonKeydown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.copy()
  }

  handleButtonKeydown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.copy()
    }
  }

  copy = (): void => {
    const value = this.dataset.value

    if (value && navigator.clipboard) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          this.showTooltip()
        })
        .catch(e => {
          if (window.Shopify.designMode) {
            // The Clipboard API blocked in Shopify editor
            this.showTooltip()
          }
          throw e
        })
    }
  }

  showTooltip(): void {
    const tooltip: ClipboardButtonTooltip = $el(`#${this.dataset.tooltipId}`)

    if (tooltip) {
      tooltip.show()

      delay(1000).then(() => {
        tooltip.hide()
      })
    }
  }
}
